import binarySearch from '../../binarySearch';

/**
 * @method getPageForPercentageOfBook
 */
const getPageForPercentageOfBook = (book, percentage) => {
  return binarySearch(book.pages, percentage, {
    isBeforeTarget: (page, comparisonValue) =>
      Math.round(page?.percentageEnd * 10000) / 10000 < comparisonValue,
    isAfterTarget: (page, comparisonValue) =>
      comparisonValue < Math.round(page?.percentageStart * 10000) / 10000,
  });
};

export default getPageForPercentageOfBook;
